import call from "../../../../service/http";
import facilityConstants from "./facilityConstants";

export default {
  state: {
    facilities: [],
  },
  mutations: {
    SET_FACILITY: (state, payload) => {
      state.facilities = payload;
    },
  },
  getters: {
    facilities: (state) => state.facilities,
  },
  actions: {
    getFacilities: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("get", facilityConstants.facilities)
        .then((res) => {
          commit("SET_FACILITY", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    addFacility: ({ commit, dispatch }, data) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("post", facilityConstants.facilities, data)
        .then(() => {
          dispatch("getFacilities");
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    removeFacility: ({ commit, dispatch }, payload) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("post", facilityConstants.remove, payload)
        .then(() => {
          dispatch("getFacilities");
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    updateFacility: ({ dispatch, commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("post", facilityConstants.update, payload)
        .then(() => {
          dispatch("getFacilities");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },
  },
};
